<div *ngIf="dropdown; else standard" class="dropdown-loading-overlay">
  <div class="spinner-border spinner-border-sm text-primary" role="status">
  </div>
</div>
<ng-template #standard>
  <div class="text-center" [class.py-2]="!small">
    <div class="spinner-border text-primary" [class.spinner-border-sm]="small" role="status">
    </div>
    <p *ngIf="message">{{message}}</p>
  </div>
</ng-template>
